const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const UIStrategy = require('../ui_strategies/ui_strategy.factory');
const pbAncillariesCollection = require('od-modules/collections/pb_ancillaries_collection/collection');
const postBookingUtils = require('../../../utils/postbooking/js/utils');
const TYPE = 'bags';

const onCatalogueHasBeenFetched = function(catalogueData) {
    this.uiStrategy = this.getUIStrategy(catalogueData);
    this.updateProduct(this.uiStrategy.getData());
    postBookingUtils.hideAncillaryCTAWhenNoCoverage(this, TYPE);
};

export default withRenderedMain(BaseView.extend({
    uiStrategyConst: {},
    uiStrategy: null,

    initialize(options = {}) {
        const props = options.props || {};

        this.updateProduct = props.updateProduct;
        this.updateChildContainerData = props.updateChildContainerData;
        this.updateConfirmButtonEnabled = props.updateConfirmButtonEnabled;
        this.updateChildContainerFooter = props.updateChildContainerFooter;
        this.onParent = props.onParent;
        this.widgetPosition = options.widgetPosition;
        this.bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
        this.childComponent = postBookingUtils.createAncillariesOffline(TYPE, this, this.bookingInfo,
            '.bags_add_popup', 'loadBags');

        const promiseCallback = onCatalogueHasBeenFetched.bind(this);
        if (!Odigeo.AB.isPostBookingBagsAndSeatsCtaAlwaysEnabled) {
            pbAncillariesCollection.loadTripBags(this.bookingInfo)
                .then(promiseCallback)
                .catch(promiseCallback);
        } else {
            promiseCallback();
        }
    },

    getUIStrategy(catalogueData) {
        return UIStrategy.factory(this.bookingInfo, catalogueData, this, this.templates, this.keys, this.uiStrategyConst);
    },

    toggleChildLayer(show) {
        if (show) {
            this.childComponent.openPopup();
        } else {
            this.childComponent.closePopup();
        }
    },
}));
